import { render, staticRenderFns } from "./ClinicDoctorsFilter.vue?vue&type=template&id=16735dac&scoped=true&"
import script from "./ClinicDoctorsFilter.vue?vue&type=script&lang=js&"
export * from "./ClinicDoctorsFilter.vue?vue&type=script&lang=js&"
import style0 from "./ClinicDoctorsFilter.vue?vue&type=style&index=0&id=16735dac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16735dac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16735dac')) {
      api.createRecord('16735dac', component.options)
    } else {
      api.reload('16735dac', component.options)
    }
    module.hot.accept("./ClinicDoctorsFilter.vue?vue&type=template&id=16735dac&scoped=true&", function () {
      api.rerender('16735dac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/desktop/ClinicDoctorsFilter/ClinicDoctorsFilter.vue"
export default component.exports